import React from 'react'

const ChevronDownSmIcon = () => (
  <svg viewBox="0 0 14 14">
    <polygon points="12.06 9.02 10.65 10.43 7.03 6.81 3.41 10.43 2 9.02 7.02 4 7.03 4.02 7.05 4 12.06 9.02" />
  </svg>
)

export default ChevronDownSmIcon
